module.exports = __webpack_public_path__ + "img/20200515_164025.1d1d41df.jpg";